// Copyright 2024 Sorama B.V.

import { Point2 } from "libraries/DataTypes/Point2";

export class SVGElementBuilder {
    private element: SVGElement;

    public createElement(type: string): SVGElementBuilder {
        this.element = document.createElementNS("http://www.w3.org/2000/svg", type);
        return this;
    }

    public setIdentifier(id: string): SVGElementBuilder {
        this.setAttribute("id", id);
        return this;
    }

    public setAttribute(name: string, value: string): SVGElementBuilder {
        this.element.setAttribute(name, value);
        return this;
    }

    public setPoints(points: Point2[]): SVGElementBuilder {
        const pointsString = points.map((p) => `${p.x},${p.y}`).join(" ");
        this.setAttribute("points", pointsString);
        return this;
    }

    public setFill(color: string, opacity = "0.2"): SVGElementBuilder {
        this.setAttribute("fill", color);
        this.setAttribute("fill-opacity", opacity);
        return this;
    }

    public setStroke(color: string, width = "1"): SVGElementBuilder {
        this.setAttribute("stroke", color);
        this.setAttribute("stroke-width", width);
        return this;
    }

    public build(): SVGElement {
        return this.element;
    }
}
